// Card 17trt6jbffe: rotas de Mensagens. Sao as mesmas para aluno
// (/customers/messages) e professor (/partners/messages) -- cada cliente ja
// tem a base certa, entao os metodos sao instalados nos dois.
//
// Ids e cursores da API sao texto (INT8 passa de Number.MAX_SAFE_INTEGER):
// nunca converter com Number().
const GET = "GET";
const POST = "POST";

const messagesMethods = {
  listMessageConversations(params = {}) {
    return this.call("/messages/conversations", GET, params);
  },

  openMessageConversation(target) {
    return this.call("/messages/conversations/open", POST, target);
  },

  listConversationMessages(conversationId, params = {}) {
    return this.call(
      `/messages/conversations/${conversationId}/messages`,
      GET,
      params
    );
  },

  sendConversationMessage(conversationId, { body, file } = {}) {
    const form = new FormData();
    if (body) form.append("body", body);
    if (file) form.append("file", file);
    return this.call(
      `/messages/conversations/${conversationId}/messages`,
      POST,
      form,
      { "Content-Type": "multipart/form-data" }
    );
  },

  markConversationRead(conversationId, upTo) {
    return this.call(
      `/messages/conversations/${conversationId}/read`,
      POST,
      upTo ? { upTo: String(upTo) } : {}
    );
  },

  getMessagesUnread() {
    return this.call("/messages/unread", GET);
  },

  getMessagesSupportSettings() {
    return this.call("/messages/support-settings", GET);
  },
};

export function installMessagesApi(ApiClass) {
  Object.entries(messagesMethods).forEach(([name, method]) => {
    if (!ApiClass.prototype[name]) ApiClass.prototype[name] = method;
  });
  return ApiClass;
}
